<template>
    <svg :class="className" :viewBox="viewBox" :width="size" :height="size" version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <path v-for="(path, index) in paths" :key="index" :d="path.d" :fill="path.fill" />
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        className: {
            type: String,
            default: 'icon'
        },
        viewBox: {
            type: String,
            default: '0 0 1024 1024'
        },
        size: {
            type: [Number, String],
            default: 32
        },
        paths: {
            type: Array,
            required: true,
            validator: value => value.every(item => 'd' in item)
        }
    }
}
</script>